module.exports = __webpack_public_path__ + "static/img/new-04.061a10b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-04.jpg
// module id = VdSX
// module chunks = 0